import { render, staticRenderFns } from "./list-vendor-premium.vue?vue&type=template&id=0917b310&scoped=true&"
import script from "./list-vendor-premium.vue?vue&type=script&lang=js&"
export * from "./list-vendor-premium.vue?vue&type=script&lang=js&"
import style0 from "./list-vendor-premium.vue?vue&type=style&index=0&id=0917b310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0917b310",
  null
  
)

export default component.exports